import { BaseWebComponent } from "../base-components/base-web-component.js";
import frameNavigation from "../../logic/FrameNavigation.js";
import { FrameComponentOptions } from "../../types/FrameComponentOptions.js";
import { FrameComponent } from "./frame-component.js";
/**
 * FrameLinkComponent - A web component that acts as a link to open a frame
 * 
 * This component is used to navigate to a specific URL in a frame, passing context data if needed.
 * It does not render any template but sets up the necessary event listeners for navigation.
 * <frame-link href="bonus-list" has-back-button="true" has-close-button="false"></frame-link>
 */
export class FrameLinkComponent extends BaseWebComponent {
    static webComponentName: string = "frame-link";
    protected _templateId: string = ""; // No template needed
    private href: string = "";
    private context: any = null;
    private _frameComponent!: FrameComponent;
    constructor() {
        super();
        this.href = this.attributeStringOption('href', '');
    }
    get frameComponent(): FrameComponent {
        return this._frameComponent;
    }
    set frameComponent(value: FrameComponent) {
        this._frameComponent = value;
        this.dispatch('frame-component-set', { frameComponent: value });
    }
    get frameComponentOptions(): FrameComponentOptions {
        const options: FrameComponentOptions = {};
        options.src = this.href;
        options.context = this.context;
        options.hasBackButton = this.attributeBoolOption('hasBackButton', true); // Default to true
        options.hasCloseButton = this.attributeBoolOption('hasCloseButton', false); // Default to false
        return options;
    }
    protected afterRender(): void {
        // non è chiamata
    }
    protected render(): void {
        // qui non c'è nessun template da renderizzare
        this.setupEventListeners();
    }
    public navigate(context: any = {}): void {
        this.context = context;
        // leggo l'attributo action se presente
        const action = this.getAttribute('action');
        this.dispatch('before-navigate', { url: this.href, context: this.context });
        this.frameComponent = frameNavigation.openFrame(this.href, this.frameComponentOptions);
        this.frameComponent.action = action || '';
        this.dispatch('navigate', { url: this.href, context: this.context, frameComponent: this.frameComponent });
    }
    protected setupEventListeners(): void {
    }
}